import { getTransactionCurrency } from './reportCurrencyUtils';

export const transactionTypeLabel = (type) => ({
  loan_payment: 'Платёж кредита',
  loan_disbursement: 'Выдача кредита',
  transfer: 'Перевод'
}[type] || null);

export const displayedReportTransactions = (transactions, whatToShow, excludeTransfers) => (
  whatToShow === 'all' && excludeTransfers
    ? transactions.filter((transaction) => transaction.type !== 'transfer')
    : transactions
);

// PERS2-86: строка category summary раскрывается allocation-строками. У
// split-операции не показываем сумму шапки в каждой дочерней категории.
export const categoryReportAllocations = (transactions, categoryId, currency) => (
  transactions.flatMap((transaction) => {
    if (getTransactionCurrency(transaction) !== currency) return [];
    const splits = Array.isArray(transaction.splits) ? transaction.splits : [];
    if (splits.length) {
      return splits
        .filter((split) => String(split.category_id) === String(categoryId))
        .map((split) => ({ ...transaction, allocationId: split.id, allocationAmount: split.amount, allocationDescription: split.description }));
    }
    return String(transaction.category_id) === String(categoryId)
      ? [{ ...transaction, allocationId: null, allocationAmount: transaction.amount, allocationDescription: transaction.description }]
      : [];
  })
);

export const reportTotalsByCurrency = (transactions, includeTransfers) => {
  const totals = new Map();
  const ensureCurrency = (currency) => {
    if (!totals.has(currency)) {
      totals.set(currency, { currency, income: 0, expense: 0, loanPayment: 0, transfer: 0 });
    }
    return totals.get(currency);
  };

  transactions.forEach((transaction) => {
    const total = ensureCurrency(getTransactionCurrency(transaction));
    const amount = Number(transaction.amount || 0);
    if (transaction.type === 'income') total.income += amount;
    if (transaction.type === 'expense') total.expense += amount;
    if (transaction.type === 'loan_payment') total.loanPayment += amount;
    if (transaction.type === 'transfer') total.transfer += amount;
  });

  return Array.from(totals.values()).map((total) => ({
    ...total,
    ...(includeTransfers ? {} : { transfer: undefined }),
    net: total.income - total.expense - total.loanPayment
  }));
};
